import type { Nullable } from "../typescript"

type HasWidthHeight = {
  width?: number
  height?: number
}

export default function isWidthHeightEqual(
  obj1: Nullable<HasWidthHeight>,
  obj2: Nullable<HasWidthHeight>,
): boolean {
  if (obj1?.width === obj2?.width) {
    if (obj1?.height === obj2?.height) {
      return true
    }
  }
  return false
}

